/**
 * Registers the service worker that keeps the 5S application available without a connection (see
 * `public/sw.js`). A release's worker stores every build file when it installs. The files this first visit
 * already loaded are also handed to it once it is active, which covers development builds without a list.
 */
export function registerAppShell(): void {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker
        .register('/sw.js')
        .then(() => navigator.serviceWorker.ready)
        .then((registration) => {
            const assets = performance
                .getEntriesByType('resource')
                .map((entry) => new URL(entry.name))
                .filter((url) => url.origin === location.origin && url.pathname.startsWith('/assets/'))
                .map((url) => url.pathname);
            registration.active?.postMessage({ type: 'cache-assets', assets });
        })
        .catch(() => undefined);
}
